import { Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import store from "@/store";
import { MIRA_COMPARISON_NONE, MiraComparisonMode } from "@/utils/MiraComparisonView";

const name = "miraComparison";

if (store.state[name]) {
  store.unregisterModule(name);
}

/**
 * The comparison a user has chosen on the Mira screens (none, the member clients of the group, and
 * later the branches of the client), shared across every Mira section screen so the choice survives a
 * move from Trocknung to Geräte within one visit.
 *
 * Deliberately **not persisted**: a comparison is a thing you turn on to look at and expect off again
 * next time, unlike the period, and only a group master can act on it at all. It resets to "no
 * comparison" on a reload.
 */
@Module({ dynamic: true, namespaced: true, store, name })
export class MiraComparisonVuexModule extends VuexModule {
  mode: MiraComparisonMode = MIRA_COMPARISON_NONE;

  @Mutation
  setMode(mode: MiraComparisonMode) {
    this.mode = mode;
  }
}

export const MiraComparisonModule = getModule(MiraComparisonVuexModule);
